import { render, staticRenderFns } from "./OrganizationTreeListView.vue?vue&type=template&id=bf1d2e90&"
import script from "./OrganizationTreeListView.vue?vue&type=script&lang=js&"
export * from "./OrganizationTreeListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports